import { config } from '../../../bootstrap/application/config/config';
import { isIframe } from './isIframe';

export const isIframeOf = (url: string) => {
  if (!isIframe()) return false;

  let href = document.referrer;

  if (href.length === 0) {
    href = document.location.href;
  }

  const urlReferrer = new URL(href);

  if (urlReferrer.origin === url) {
    return true;
  }

  const [firstPathname] = urlReferrer.pathname.split('/').filter(p => p);

  if (firstPathname) {
    return `${urlReferrer.origin}/${firstPathname}` === url;
  }

  return false;
};

export const isIframeOfAddonMeet = () => {
  return isIframeOf(config.urls.addonMeet);
};
